// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Dialog {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: rgba(128, 128, 128, 0.1);
  padding: 8px;
}`, "",{"version":3,"sources":["webpack://./components/Charts/dialoge.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,0CAAA;EACA,YAAA;AACF","sourcesContent":[".Dialog {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: rgb(128, 128, 128, 0.1);\n  padding: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
